var image_card = document.querySelectorAll('.card__inner');


image_card.forEach(card => {
  var cellAlign = 'left';
  var cells = card.querySelectorAll('.image-card');
  if(window.innerWidth >= 768 ){
    var hasMultipleCells = cells.length > 3,
        groupCells = 3
  }
  else if(window.innerWidth >= 475 ){
    var hasMultipleCells = cells.length > 2,
        groupCells = 2,
        cellAlign = 'center'
  }
  else{
    var hasMultipleCells = cells.length > 1;
        groupCells = 1,
        cellAlign = 'center'
  }
  if(hasMultipleCells) {
    var flkty = new Flickity(card, {
      cellAlign: cellAlign,
      contain: true,
      groupCells: groupCells,
      wrapAround: true,
      pauseAutoPlayOnHover: true,
    });
  }
})